import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import moment from 'moment';
import {
  LANGUAGE_QUERY_PARAM,
  PREFERRED_LANGUAGE_STORAGE_KEY,
  readLanguageFromSearch,
  readPreferredLanguage
} from '@/app/core/pages/public-account/language-selector/language-selector.component';
import { momentLocaleFor } from '@shared/utils/moment-locale.utils';

/**
 * Herstelt de bewaarde taalkeuze uit localStorage bij het opstarten. Zonder bewaarde
 * keuze blijft de Transloco-standaardtaal (EN sinds 0.9.1) actief; bestaande
 * installaties kregen bij de versiewissel hun oude NL-standaard als keuze
 * (zie AppVersionInitializer).
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageInitializer {
  constructor(private readonly transloco: TranslocoService) {}

  init(): void {
    // Dag- en maandnamen van moment volgen de app-taal (vroeger stond de
    // locale vast op LOCALE_ID nl-BE, ook in het Engels). Ingeschreven bij het
    // opstarten, vóór de signal-bronnen van de taal: de globale locale is dus
    // al gewisseld wanneer computeds na een taalwissel herrekenen.
    this.transloco.langChanges$.subscribe(lang => moment.locale(momentLocaleFor(lang)));

    // De landingspagina geeft haar taal mee (?lang=nl|en): die keuze wint, wordt bewaard
    // zoals een keuze in de taalkiezer, en verdwijnt daarna uit de adresbalk.
    const languageFromUrl = readLanguageFromSearch(window.location.search);
    if (languageFromUrl) {
      localStorage.setItem(PREFERRED_LANGUAGE_STORAGE_KEY, languageFromUrl);
      removeLanguageFromUrl();
    }

    const preferredLanguage = readPreferredLanguage();
    if (preferredLanguage) {
      this.transloco.setActiveLang(preferredLanguage);
    }
  }
}

function removeLanguageFromUrl(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(LANGUAGE_QUERY_PARAM);
  history.replaceState(history.state, '', url.toString());
}
